import {
  faCheckCircle,
  faExclamationCircle,
  faExclamationTriangle,
  faInfoCircle,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { ReactNode } from 'react';

import { Box } from '../Box/Box';
import { alertRecipe } from './Alert.css';

type AlertTone = 'success' | 'warning' | 'critical' | 'info';

const iconMap: { [key in AlertTone]: ReactNode } = {
  success: <FontAwesomeIcon icon={faCheckCircle} />,
  critical: <FontAwesomeIcon icon={faExclamationCircle} />,
  warning: <FontAwesomeIcon icon={faExclamationTriangle} />,
  info: <FontAwesomeIcon icon={faInfoCircle} />,
};

type AlertProps = {
  /** The tone dictates the colour and icon in the alert */
  tone?: AlertTone;
  /** Defaults to true */
  rounded?: boolean;
  /** Overrides default tone resolved icon, e.g. a lock icon */
  icon?: ReactNode;
  children: ReactNode;
};

export function Alert({ tone = 'info', rounded = true, icon, children }: AlertProps): JSX.Element {
  return (
    <Box
      padding={'medium'}
      display={'flex'}
      flexDirection={'row'}
      alignItems={'center'}
      gap={'small'}
      borderRadius={rounded ? 'standard' : 'none'}
      className={alertRecipe({ tone })}
    >
      {icon ?? iconMap[tone]}
      {children}
    </Box>
  );
}
